import React, { useContext } from "react"
import Layout from "../components/layout"
import PageTeasers from "../components/page-teasers.js"
// import LocomotiveScroll from 'locomotive-scroll'

// markup
const IndexPage = (props) => {
    // const locoScroll = new LocomotiveScroll;
    // const { locomotive } = useContext(locoScroll);
    
    return (
        <Layout>
            <main>
                <title>Home Page</title>
                <PageTeasers indexProps={props} />
            </main>
        </Layout>
    )
}

export default IndexPage
